<template>
  <div class="signin-page">
    <div class="signin-page__wrapper">
      <div class="signin-page__header">
        <h2 class="small-title title">Please Sign in to continue</h2>
        <p class="description">The page you are trying to visit requires to using your account.</p>
      </div>
      <div class="signin-page__mediasocial">
        <button class="btn-block facebook subhead not-rounded" @click="socialLogin(`facebook`, currentRoute)">
          <i class="adx-ic_facebook"></i>
          Sign in with Faceboook
        </button>
        <button class="btn-block secondary google subhead not-rounded" @click="socialLogin(`google`, currentRoute)">
          <i class="adx-ic_google"></i>
          Sign in with Google
        </button>
      </div>
      <div class="signin-page__divider">
        <span></span>
        <div class="or">OR</div>
        <span></span>
      </div>
      <div class="signin-page__input">
        <adx-form
          @complete="complete"
          @error400="error400"
          :schema="schema"
          :formType="'login'"
          :model.sync="model"
          :error.sync="error"
          :onSubmit="onSubmit"
          :wrapper="wrapper" />
      </div>
      <div class="signin-page__footer">
          <div class="signup subhead">
            Don’t have an account ? <span class="subhead" @click.stop="goToSignup">Sign up</span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import FormAbstraction from '@/components/Form'

import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
import { authMixin } from '@/lib/mixins/authMixin'

const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-signin-page',
  components: {
    'adx-form': FormAbstraction
  },
  mixins: [ authMixin ],
  props: {

  },
  data() {
    return {
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        password: ``,
        remember: ``,
        next: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Sign in`,
            uri: apiV2.signin,
            params: this.model,
            method: `post`, // HTTP Method
            class: `btn-block primary signin not-rounded`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'hidden',
          fields: [
            {
              type: 'input',
              inputType: 'hidden',
              model: 'next'
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email',
              model: 'email',
              method: 'onChange',
              validation: ['NotEmpty', 'Email']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Password',
              model: 'password',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        },
        {
          type: 'flex__right',
          fields: [
            {
              type: 'link',
              label: 'Forgot Password',
              to: 'forgot-password'
            }
          ]
        },
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { next } = this.$route.query
    if (next) {
      this.model.next = next
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    complete($event) {
      (async () => {
        const response  = await this.$store.dispatch('getAccount', $event.args.data)
        await this.$store.dispatch(`setProfile`)

        // await this.$router.push({path: $event.args.data.redirect_to})
        
        window.location = $event.args.data.redirect_to
        // console.log($event.args.data.redirect_to)
        
      })();
    },
    error400($event) {
      const { redirect_to, message, ...response } = $event.data
      if (redirect_to) {
        this.toggleModal()
        this.$router.push(redirect_to)
      } else {
        if (message === 'with_social_login') {
          this.$router.push({name: 'sociallogin', query: { name: response.name, email: response.email, provider: response.provider, avatar: response.avatar }})
        }
      }
    },
    goToSignup() {
      this.$router.push({name: 'signup'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>